<template>

    <div class="mockup" ref="mockup" :style="{'height': `${mockupHeight}px`}">
        <img v-for="mockupImage in mockupImages" v-if="mockupImage.url && mockupImage.url !== false" :src="mockupImage.url" :style="mockupImageStyle(mockupImage)" alt="">
    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditorMockup',

    props: {
        mockupImages: Array
    },

    data() {
        return {
            isMounted: false,
            mockupOriginWidth: 640,
            mockupOriginHeight: 400,
            mockupCurrentWidth: 640,
        }
    },

    computed: {
        mockupScaleFactor() {
            if (!this.isMounted) {
                return 0;
            }
            return this.mockupCurrentWidth / this.mockupOriginWidth;
        },
        mockupHeight() {
            return this.mockupOriginHeight * this.mockupScaleFactor;
        },
        mockupImageValueScaled() {
            return originalValue => {
                return originalValue * this.mockupScaleFactor;
            }
        },
        mockupImageStyle() {
            return mockupImage => {
                let style = {
                    'width': `${this.mockupImageValueScaled(mockupImage.size_x)}px`,
                    'height': `${this.mockupImageValueScaled(mockupImage.size_y)}px`,
                    'top': `${this.mockupImageValueScaled(mockupImage.position_y)}px`,
                    'left': `${this.mockupImageValueScaled(mockupImage.position_x)}px`
                };
                if (mockupImage.hasOwnProperty('rotation')) {
                    style['transform'] = `rotate(${mockupImage.rotation}deg)`
                }
                return style;
            }
        },
    },

    beforeMount() {

    },

    created() {
        window.addEventListener('resize', this.setMockupCurrentWidth);
    },

    mounted() {
        this.isMounted = true;

        this.setMockupCurrentWidth();
    },

    unmounted() {
        window.removeEventListener('resize', this.setMockupCurrentWidth);
    },

    methods: {
        setMockupCurrentWidth() {
            this.mockupCurrentWidth = this.$refs.mockup.clientWidth;
        },
    }

}
</script>

<style scoped>

</style>
